import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye, EyeOff, ShieldCheck, Landmark } from "lucide-react";
import { api, BRL } from "@/lib/api";


const Item = ({ to, icon: I, label, bank, value, show, testid }) => (
  <Link to={to} className="flex-1 min-w-0 flex items-center gap-2 group" data-testid={testid}>
    <I className="w-4 h-4 text-slate-400 shrink-0" />
    <span className="min-w-0">
      <span className="block text-[9.5px] font-bold uppercase tracking-wide text-slate-400 leading-tight truncate">{bank}</span>
      <span className="block text-[10px] font-semibold text-slate-500 leading-tight truncate">{label}</span>
      <span className="block text-[13px] font-black tabular-nums text-slate-800 leading-tight group-hover:text-[#1e3a8a] transition-colors">
        {show ? (value == null ? "…" : BRL(value)) : "R$ ••••"}
      </span>
    </span>
  </Link>
);

export const BalancesStrip = () => {
  const [show, setShow] = useState(false);
  const [caixa, setCaixa] = useState(null);
  const [dia, setDia] = useState(null);
  useEffect(() => {
    if (!show) return;
    api.get("/finance/caixa").then((r) => setCaixa(r.data.balance)).catch(() => {});
    api.get("/finance/conta-dia").then((r) => setDia(r.data.balance)).catch(() => {});
  }, [show]);
  const toggle = () => setShow((v) => !v);
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-white border border-slate-200 px-3 py-2.5" data-testid="balances-strip">
      <Item to="/financeiro/caixa" icon={ShieldCheck} label="Caixa da empresa" bank="99Pay" value={caixa} show={show} testid="balance-caixa" />
      <span className="w-px h-7 bg-slate-200" />
      <Item to="/financeiro/conta-dia" icon={Landmark} label="Conta do dia a dia" bank="PagSeguro" value={dia} show={show} testid="balance-conta-dia" />
      <button type="button" onClick={toggle} className="p-2 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors shrink-0"
        aria-label={show ? "Esconder saldos" : "Mostrar saldos"} data-testid="balances-toggle">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};
